export const NAME_REQUIRED_ERROR = 'Name wird benötigt';
export const MESSAGE_REQUIRED_ERROR = 'Nachricht wird benötigt';
export const EMAIL_REQUIRED_ERROR = 'Ungültige Email-Adresse';
